import script from "./ErrorGenerate.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorGenerate.vue?vue&type=script&setup=true&lang=js"

import "./ErrorGenerate.vue?vue&type=style&index=0&id=2b31e492&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b31e492"]])

export default __exports__